import { defineComponent as _defineComponent } from 'vue'
import { type ExWindow } from '@ve/types';
  import { useViewport } from '@travelata-libs/utils';
  import { isWithinInterval } from 'date-fns';
  import { computed, ref } from 'vue';
  import CashbackModal from '@ve/components/cashback/CashbackModal.vue';

  declare let window: ExWindow;

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GiftCertificatesBanner',
  props: {
    link: {
      type: String,
      default:
        'https://gift.travelata.ru/?utm_source=travelata&utm_medium=banner&utm_campaign=gift_certificates&utm_content=main',
    },
    openInNewTab: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Чтобы подарок ',
    },
    titleWrapping: {
      type: String,
      default: 'не пылился на полке',
    },
    subtitle: {
      type: String,
      default: 'Сертификат на отдых — лучший сюрприз для близких',
    },
    buttonText: {
      type: String,
      default: 'Выбрать сертификат',
    },
    isSearchPage: {
      type: Boolean,
      default: false,
    },
    showDiscountBanner: {
      type: Boolean,
      default: false,
    },
    showCashbackBanner: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
    customClassContainer: {
      type: String,
      default: '',
    },
  } as const,
  setup(__props) {

const props = __props

  

  const { isMobile } = useViewport();
  const cashbackModalRef = ref<InstanceType<typeof CashbackModal> | null>(null);

  const discountStart = new Date(Date.UTC(2026, 1, 3, 0, 1));
  const discountEnd = new Date(Date.UTC(2026, 1, 15, 23, 59, 59, 999));

  const inDiscountDateRange = computed(() => {
    return isWithinInterval(new Date(), { start: discountStart, end: discountEnd });
  });

  const shouldShowDiscountBanner = computed(() => inDiscountDateRange.value && props.showDiscountBanner);
  const shouldShowCashbackBanner = computed(
    () => props.showCashbackBanner && window?.appConfig?.vamPrivet,
  );
  const isMobileSearchPage = computed(() => isMobile.value && props.isSearchPage);

  const openLinkCertificates = (): void => {
    if (shouldShowCashbackBanner.value) {
      cashbackModalRef.value?.open?.();
      return;
    }

    if (props.openInNewTab) {
      window.open(props.link, '_blank', 'noopener');
    } else {
      window.location.href = props.link;
    }
  };

return { __sfc: true,props, isMobile, cashbackModalRef, discountStart, discountEnd, inDiscountDateRange, shouldShowDiscountBanner, shouldShowCashbackBanner, isMobileSearchPage, openLinkCertificates, CashbackModal }
}

})